<div class="form-builder-page">
  <div class="page-header">
    <button mat-icon-button (click)="goBack()" matTooltip="Volver">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="titles">
      <h1>Formulario: {{ subcategory?.subcategoryName }}</h1>
      <span class="subtitle">Diseña los campos que verá el cliente al crear una solicitud</span>
    </div>
    <span class="spacer"></span>
    <mat-slide-toggle [checked]="showJson" (change)="showJson = $event.checked">Ver JSON</mat-slide-toggle>
    <button mat-raised-button color="primary" (click)="save()">
      <mat-icon>save</mat-icon>
      Guardar formulario
    </button>
  </div>

  <div class="builder-layout">
    <div class="builder-column">
      <app-field-list
        [fields]="fields"
        (fieldsChange)="onFieldsChange($event)">
      </app-field-list>
    </div>

    <div class="preview-column">
      <ng-container *ngIf="!showJson; else jsonView">
        <div class="phone-frame">
          <div class="phone-header">
            <mat-icon>smartphone</mat-icon>
            <span>Vista previa</span>
          </div>
          <div class="phone-body">
            <app-form-preview [fields]="fields"></app-form-preview>
          </div>
        </div>
      </ng-container>
      <ng-template #jsonView>
        <mat-card class="json-card">
          <pre>{{ fieldsJson }}</pre>
        </mat-card>
      </ng-template>
    </div>
  </div>
</div>
